if (!customElements.get('sticky-product-bar')) {
  customElements.define(
    'sticky-product-bar',
    class StickyProductBar extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.button = this.querySelector('.sticky-product-bar__button');
        this.isSoldOut = this.dataset.soldOut === 'true';
      }

      connectedCallback() {
        // Wait for DOM to be ready before initializing
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init());
        } else {
          this.init();
        }
      }

      init() {
        this.mainBuyButton = document.querySelector(`#ProductSubmitButton-${this.sectionId}`);

        if (!this.mainBuyButton) {
          console.warn('[StickyProductBar] Buy button not found:', `#ProductSubmitButton-${this.sectionId}`);
          return;
        }

        // Set up IntersectionObserver to track when main buy button leaves viewport
        this.observer = new IntersectionObserver(
          (entries) => this.handleIntersect(entries),
          {
            root: null,
            rootMargin: '0px',
            threshold: 0
          }
        );

        this.observer.observe(this.mainBuyButton);

        // Set up click handler
        if (this.button && !this.isSoldOut) {
          this.button.addEventListener('click', () => this.handleClick());
        }
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
      }

      handleIntersect(entries) {
        const entry = entries[0];
        // Show sticky bar when main buy button is NOT visible
        if (!entry.isIntersecting) {
          this.classList.add('is-visible');
        } else {
          this.classList.remove('is-visible');
        }
      }

      handleClick() {
        // Trigger click on the main buy button
        if (this.mainBuyButton && !this.mainBuyButton.disabled) {
          this.mainBuyButton.click();
        }
      }
    }
  );
}
